<!-- Admin Users Management - Bootstrap 5.3.7 Layout -->
<div class="admin-users-container">
  
  <!-- Page Header -->
  <div class="page-header bg-white border-bottom shadow-sm mb-4 sticky-top">
    <div class="container-fluid py-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="h3 mb-0 text-gray-800">
            <i class="fa fa-users me-2 text-primary"></i>
            User Management
          </h1>
          <p class="text-muted mb-0">Manage intercessory prayer training users</p>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-outline-success btn-sm" (click)="exportexcel()">
            <i class="fa fa-download me-1"></i>
            Export to Excel
          </button>
          <button type="button" 
                  class="btn btn-outline-primary btn-sm"
                  (click)="refreshPage()"
                  [disabled]="isRefreshing">
            <i class="fa" 
               [class.fa-sync]="!isRefreshing" 
               [class.fa-spinner]="isRefreshing" 
               [class.fa-spin]="isRefreshing" 
               class="me-1"></i>
            {{ isRefreshing ? 'Refreshing...' : 'Refresh' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="container-fluid pb-4">

    <!-- Search Filter Card -->
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-header bg-primary bg-gradient text-white">
        <h5 class="card-title mb-0">
          <i class="fa fa-search me-2"></i>
          Search Users
        </h5>
      </div>
      <div class="card-body">
        <form #form="ngForm" (ngSubmit)="filterUsers()" autocomplete="off">
          <div class="row g-3">
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-semibold">
                <i class="fa fa-envelope me-1 text-primary"></i>
                Email
              </label>
              <input 
                type="email" 
                class="form-control" 
                name="email" 
                [(ngModel)]="userParams.username"
                placeholder="Enter email address">
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-semibold">
                <i class="fa fa-user me-1 text-success"></i>
                First Name
              </label>
              <input 
                type="text" 
                class="form-control" 
                name="firstname" 
                [(ngModel)]="userParams.firstname"
                placeholder="Enter first name">
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-semibold">
                <i class="fa fa-user me-1 text-info"></i>
                Last Name
              </label>
              <input 
                type="text" 
                class="form-control" 
                name="lastname" 
                [(ngModel)]="userParams.lastname"
                placeholder="Enter last name">
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <label class="form-label fw-semibold">
                <i class="fa fa-list me-1 text-warning"></i>
                Show Results
              </label>
              <select 
                class="form-select" 
                name="pageSize" 
                [(ngModel)]="userParams.pageSize" 
                (change)="itemsPerPageChanged()">
                <option [ngValue]="2">2 users</option>
                <option [ngValue]="5">5 users</option>
                <option [ngValue]="10">10 users</option>
                <option [ngValue]="20">20 users</option>
                <option [ngValue]="50">50 users</option>
                <option [ngValue]="100">100 users</option>
                <option [ngValue]="200">200 users</option>
                <option [ngValue]="100000">All users</option>
              </select>
            </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button class="btn btn-primary" type="submit">
              <i class="fa fa-search me-1"></i>
              Filter Users
            </button>
            <button class="btn btn-outline-secondary" type="button">
              <i class="fa fa-times me-1"></i>
              Clear
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Users Table Card -->
    <form #usersForm="ngForm">
      <div class="card border-0 shadow-sm">
        <div class="card-header bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0 text-primary fw-bold">
              <i class="fa fa-table me-2"></i>
              User Information & Progress
            </h5>
            <span class="badge bg-primary fs-6" *ngIf="pagination">
              {{pagination.totalItems}} Total Users
            </span>
          </div>
        </div>
        <div class="card-body p-0">
          
          <!-- Responsive Table -->
          <div class="table-responsive">
            <table class="table table-hover table-striped mb-0">
              <thead class="table-primary">
                <tr>
                  <th class="fw-bold">
                    <i class="fa fa-user me-1"></i>
                    User Details
                  </th>
                  <th class="fw-bold">
                    <i class="fa fa-envelope me-1"></i>
                    Email
                  </th>
                  <th class="fw-bold text-center" colspan="10">
                    <i class="fa fa-graduation-cap me-1"></i>
                    Class Progress (1-10)
                  </th>
                  <th class="fw-bold text-center">
                    <i class="fa fa-check-circle me-1"></i>
                    Confirmed
                  </th>
                  <th class="fw-bold text-center">
                    <i class="fa fa-cog me-1"></i>
                    Actions
                  </th>
                </tr>
                <tr class="table-light">
                  <th></th>
                  <th></th>
                  <th class="text-center small fw-semibold">C1</th>
                  <th class="text-center small fw-semibold">C2</th>
                  <th class="text-center small fw-semibold">C3</th>
                  <th class="text-center small fw-semibold">C4</th>
                  <th class="text-center small fw-semibold">C5</th>
                  <th class="text-center small fw-semibold">C6</th>
                  <th class="text-center small fw-semibold">C7</th>
                  <th class="text-center small fw-semibold">C8</th>
                  <th class="text-center small fw-semibold">C9</th>
                  <th class="text-center small fw-semibold">C10</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>                <tr *ngFor="let item of this.users" class="align-middle">
                  <td>
                    <a 
                      [routerLink]="['/backoffice/user', item.userId]" 
                      class="text-decoration-none">
                      <div class="d-flex align-items-center">
                        <div class="me-2">
                          <i class="fa fa-chevron-right text-primary"></i>
                        </div>
                        <div>
                          <div class="fw-semibold text-dark">{{item.firstName}} {{item.lastName}}</div>
                          <small class="text-muted">ID: {{item.userId}}</small>
                        </div>
                      </div>
                    </a>
                  </td>
                  <td>
                    <span class="badge bg-light text-dark border">{{item.email}}</span>
                  </td>

                  <!-- Class Progress Icons -->
                  <td class="text-center" *ngFor="let classNum of [1,2,3,4,5,6,7,8,9,10]">
                    <div class="position-relative">
                      <img 
                        class="rounded" 
                        width="28" 
                        height="28" 
                        [src]="this.getUCInfo(item, classNum)"
                        [alt]="'Class ' + classNum + ' status'"
                        [title]="'Class ' + classNum + ' - ' + (this.classCompleted ? 'Completed' : 'Not Completed')">
                    </div>
                  </td>
                  
                  <!-- Confirmed Status -->
                  <td class="text-center">
                    <div class="form-check form-switch d-flex justify-content-center">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        role="switch"
                        [id]="'confirmed-' + item.userId"
                        [checked]="item.emailConfirmed"
                        (change)="toggleUserConfirmation(item, $event)"
                        [disabled]="item.isUpdating">
                      <label class="visually-hidden" [for]="'confirmed-' + item.userId">
                        Toggle confirmation status for {{item.firstName}} {{item.lastName}}
                      </label>
                    </div>
                  </td>
                  
                  <!-- Actions -->
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-1">
                      <button 
                        type="button" 
                        class="btn btn-outline-danger btn-sm"
                        (click)="confirmDeleteUser(item)"
                        [disabled]="item.isDeleting"
                        [title]="'Delete user: ' + item.firstName + ' ' + item.lastName">
                        <i class="fa" 
                           [class.fa-trash]="!item.isDeleting" 
                           [class.fa-spinner]="item.isDeleting" 
                           [class.fa-spin]="item.isDeleting"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Table Footer with Pagination -->
          <div class="card-footer bg-light">
            <div class="row align-items-center">
              <div class="col-12 col-md-6">
                <p class="mb-0 text-muted small" *ngIf="pagination">
                  <i class="fa fa-info-circle me-1"></i>
                  Showing {{((pagination.currentPage - 1) * pagination.itemsPerPage) + 1}} 
                  to {{Math.min(pagination.currentPage * pagination.itemsPerPage, pagination.totalItems)}} 
                  of {{pagination.totalItems}} users
                </p>
              </div>
              <div class="col-12 col-md-6">
                <nav class="d-flex justify-content-md-end mt-2 mt-md-0" *ngIf="pagination">
                  <pagination 
                    [boundaryLinks]="true"  
                    [totalItems]="pagination.totalItems"
                    [itemsPerPage]="pagination.itemsPerPage" 
                    [(ngModel)]="pagination.currentPage"
                    [ngModelOptions]="{standalone: true}"
                    (pageChanged)="pageChanged($event)"  
                    previousText="&lsaquo;" 
                    nextText="&rsaquo;" 
                    firstText="&laquo;" 
                    lastText="&raquo;"
                    class="pagination-sm">
                  </pagination>
                </nav>
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>

  </div>
</div>